<section class="page-container">
  <mat-card  class="sign-up-card mat-elevation-z7">
    <mat-progress-bar mode="indeterminate" *ngIf='authLoading | async'></mat-progress-bar>
    <section class="text">
      <mat-card-content>
        <h1>Create An Account</h1>
      </mat-card-content>
    </section>
    <div class="sign-up" *ngIf='authState === "LOGIN"'>
      <section class="res-logo">
        <div class="logo-wrap">
          <img src="../../../../assets/logos/gtap-logo.jpg" />
        </div>
      </section>

      <section class="form">
        <form [formGroup]="signUpForm" (ngSubmit)="submit()">
          <formly-form
            [model]="model"
            [fields]="fields"
            [options]="options"
            [form]="signUpForm"
          ></formly-form>
          <section class="registering">
            <div class="register-button">
              <button mat-raised-button color="primary" [disabled]="signUpForm.invalid">Register Account</button>
            </div>
            <div class="help-registering">
              <a href="auth/reset-password">Forgot Password?</a>
              <a href="auth/login">Already have an account? Login!</a>
            </div>
          </section>
        </form>
      </section>
    </div>

    <div fxFlex *ngIf='authState === "CONFIRM_SIGN_UP"'>
      <section fxLayout="column" fxLayoutAlign="center center" fxFlex="40" class="res-logo">
        <div class="logo-wrap">
          <img src="../../../../assets/logos/gtap-logo.jpg" />
        </div>
      </section>
      <section fxLayout="column" fxFlex="60" class="sign-up-wrapper">
        <mat-card-content>
          <h1 fxLayoutAlign="center">Authorization Code</h1>
          <p>{{authMessage | async}}</p>
        </mat-card-content>
        <div>
          <form [formGroup]="confirmationForm" (ngSubmit)="confirmAccount()">
            <formly-form
              [model]="confirmationModel"
              [fields]="confirmationFormField"
              [options]="options"
              [form]="confirmationForm"
            ></formly-form>
            <button mat-raised-button color="primary" fxFill [disabled]="confirmationForm.invalid">Confirm Account</button>
          </form>
        </div>
      </section>
    </div>
  </mat-card>
</section>
